import React from 'react';
import {
    ArrayField,
    Datagrid,
    TextField,
    BooleanField,
    NumberField,
    FunctionField,
} from 'react-admin';
import CustomTableShow from './CustomTableShow';

class QuestionShow extends CustomTableShow {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'level') {
            fieldList.push(<FunctionField label="Level" render={record => record.level || 'fundamental'} />)
            fieldList.push(<FunctionField label="Level Score" render={record => `${record.level === 'mastery' ? 3 : record.level === 'advanced' ? 2 : 1}`} />)
            return true
        } else if (fieldName === 'questions') {
            fieldList.push(<ArrayField source="questions">
                <Datagrid linkType={false}>
                    <TextField label="Question" source="question"/>
                    <ArrayField source="answers">
                        <Datagrid linkType={false}>
                            <TextField label="Answer" source="answer"/>
                            <BooleanField label="Right Answer" source="rightAnswer"/>
                            <NumberField label="Order" source="order"/>
                        </Datagrid>
                    </ArrayField>
                </Datagrid>
            </ArrayField>)
            return true
        }
        return false
    }
}

export default QuestionShow;
